<div class="rounded menu">
    <div class="item" (click)="getPageHelp.emit(helpPaths)">
      Product Documentation
    </div>
    <div class="divider" ></div>
    <div class="item" (click)="openSupport()">
      Contact Support
    </div>
</div>
